import React from 'react';
import { TEXT_COLOR } from '../../theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { getText } from '../common/MultiLanguageText';

const AI_THRESHOLDS = [
    { min: 0.80, label: 'Likely AI-generated', color: '#c62828' },
    { min: 0.50, label: 'Uncertain',           color: '#e65100' },
    { min: 0,    label: 'Likely human',         color: '#2e7d32' },
];

function aiInfo(answer) {
    const detections = answer?.ai_detections;
    if (!detections?.length) return null;
    const d = detections[0];
    const pct = Math.round(d.score * 100);
    const { label, color } = AI_THRESHOLDS.find(t => d.score >= t.min);
    return { pct, label, color, provider: d.provider };
}

function AiDetectionBadge({ info }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
            <Box sx={{
                width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                bgcolor: info.color,
            }} />
            <Typography sx={{ fontSize: '12px', color: info.color, fontWeight: 600 }}>
                {info.label}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#64748B' }}>
                {info.provider}: <strong>{info.pct}%</strong>
            </Typography>
        </Box>
    );
}

export default function SurveyResponsesCard({ tr, language, questions, answers }) {
    return (
        <Box sx={{
            bgcolor: '#fff',
            border: '1px solid #E1E4E8',
            borderRadius: '14px',
            boxShadow: '0 1px 2px rgba(15,17,35,0.04)',
            p: 3,
        }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 700, color: TEXT_COLOR, mb: 0.5 }}>
                {tr('questions')}
            </Typography>
            <Typography sx={{ fontSize: '13px', color: TEXT_COLOR, mb: 3 }}>
                Read-only · AI authenticity scored per answer
            </Typography>

            {questions.map((question, index) => {
                if (!question) return null;
                const answer = answers[index];
                const info = aiInfo(answer);
                return (
                    <Box key={index}>
                        {index > 0 && <Divider sx={{ my: 2.5 }} />}
                        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: TEXT_COLOR, mb: 1.5 }}>
                            {question.order}. {getText(question, 'question', language)}
                        </Typography>
                        <Box sx={{
                            bgcolor: '#F8F9FC',
                            border: '1px solid #E1E4E8',
                            borderRadius: '8px',
                            p: 2,
                            fontSize: '14px',
                            color: TEXT_COLOR,
                            lineHeight: 1.6,
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'inherit',
                        }}>
                            {answer?.answer || '—'}
                        </Box>
                        {info && <AiDetectionBadge info={info} />}
                    </Box>
                );
            })}
        </Box>
    );
}
